import React from "react";
import { Card } from "@/components/ui/card";
import { Database, Eye, Brain, Activity, Globe, CheckCircle } from "lucide-react";
import bgImage from "@/assets/key-differentiators-bg.jpg";

const KeyDifferentiatorsSection = () => {
  const differentiators = [
    {
      icon: Database,
      title: "Organizational Memory",
      description: "Retains institutional threat intelligence even when teams change."
    },
    {
      icon: Eye,
      title: "Shadow AI Detection",
      description: "Identifies and neutralizes unauthorized AI models or rogue analytics."
    },
    {
      icon: Brain,
      title: "Cognitive Threat Reasoning",
      description: "Understands context and intent like a human analyst, at scale."
    },
    {
      icon: Activity,
      title: "Dynamic Risk Scoring",
      description: "Continuously recalculates risk for assets, identities, and behaviors."
    },
    {
      icon: Globe,
      title: "Threat Intelligence Fusion",
      description: "Correlates internal and external data into a unified cyber graph."
    },
    {
      icon: CheckCircle,
      title: "Trustworthy AI",
      description: "Transparent, auditable, and compliant with enterprise governance."
    }
  ];

  return (
    <section 
      className="py-16 md:py-20 relative bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-6xl mx-auto space-y-12">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              Key Differentiators
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {differentiators.map((item, index) => (
              <Card key={index} className="p-6 text-center hover:shadow-lg transition-shadow border-2 border-white/20 bg-black/40 backdrop-blur-sm hover:border-[#8932c8]/50">
                <div className="space-y-4">
                  <div className="flex justify-center">
                    <div className="w-16 h-16 rounded-full bg-[#8932c8]/20 flex items-center justify-center">
                      <item.icon className="w-8 h-8 text-[#8932c8]" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-white">{item.title}</h3>
                  <p className="text-white/80">{item.description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyDifferentiatorsSection;
